<template>
  <div>
    <div>{{ field.label }}</div>
    <v-layout v-show="error" @click="error = null">{{ error }}</v-layout>
    <v-layout class="mb-2">
      <v-btn
        @click="openFileDialog"
        :loading="loading"
        :disabled="loading"
        color="blue-grey"
        class="white--text"
      >
        Загрузить файл
        <v-icon right dark>cloud_upload</v-icon>
      </v-btn>
      <input id="file_upload" type="file" @change="onFileChange" />
    </v-layout>

    <v-dialog v-model="dialog" max-width="440">
      <v-card>
        <v-card-title class="headline">Удалить файл?</v-card-title>

        <v-card-text>
          Файл будет удален с сервера
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="white darken-1" text @click="dialog = false">
            Отмена
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="
              dialog = false;
              delete_file($parent.type, $parent.id);
            "
          >
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import images from "./../../api/images";

export default {
  name: "ImageField",
  props: ["entity", "field", "value"],
  computed: {
    image_src: {
      get() {
        return this.image_base_source;
      },
      set(value) {
        this.image_base_source = value;
      }
    }
  },
  data() {
    return {
      updated: false,
      loading: false,
      dialog: false,
      error: null
    };
  },
  methods: {
    clearError() {
      this.error = null;
    },
    openFileDialog() {
      document.getElementById("file_upload").click();
    },
    async onFileChange(e) {
      let file = e.target.files[0];

      this.loading = true;
      this.$parent.entity[this.field.name] = file.name;

      // TODO: replace with universal endpoint/API
      const result = await images.upload(this.token, file);
      this.loading = false;
      if (!result.success) this.error = result.data.message;
      else {
        this.$parent.entity[this.field.name] = result.filename;
      }
    },
    async delete_file(entity_type, entity_id) {
      const result = await images.delete(this.token, entity_type, entity_id);
      if (result.data.result === true) {
        this.loading = false;
      } else {
        this.loading = false;
        this.error = result.data.message;
      }
    }
  }
};
</script>

<style scoped>
#file_upload {
  display: none;
}
</style>
